/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropkinddraw2Inputs */

const en_dropkinddraw2 = /** @type {(inputs: Dropkinddraw2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draw`)
};

const de_dropkinddraw2 = /** @type {(inputs: Dropkinddraw2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verlosung`)
};

/**
* | output |
* | --- |
* | "Draw" |
*
* @param {Dropkinddraw2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropkinddraw2 = /** @type {((inputs?: Dropkinddraw2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropkinddraw2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropkinddraw2(inputs)
	return de_dropkinddraw2(inputs)
});
export { dropkinddraw2 as "dropKindDraw" }